import React, {useState, useEffect } from "react"
import AgenceCard from "./agenceCard"
import GoogleMapReact from 'google-map-react';

const AnyReactComponent = ({ text }) => <div>{text}<img src={require("../../../styles/medias/images/icon-marker.svg" )} /></div>;

export default ({agences}) => {
    const agencies = agences && [...agences];
    agencies.forEach(function (agence) {
        agence === agencies[0] ? agence.isShown = true : agence.isShown = false;
      }); 

    const [isClicked, setIsClicked] = useState(false);
    const [itemClicked, setItemClicked] = useState(1);
    const [itemActive, setItemActive] = useState(1);
    const [showMap, setShowMap] = useState(false);


    useEffect( () => {
                if (isClicked && itemClicked !== itemActive ){
                    setItemActive(itemClicked);
                    setShowMap(false);
                }
            }, [isClicked,itemClicked]);
//agencies[id].isShown = !agencies[id].isShown
    return (
        <div className="section--6 p-t-30">
            <div className="container title">
                <h2>Nos AGENCES</h2>
            </div>
            <div className="content-agence">
                <div className="row">
                    <div className="col-md-7 liste-ville">
                        <div id="accordion">
                            { agencies && agencies.map( agence => {
                                return(
                                    /* <AgenceCard key={agence.id+''} data={agence} hide={(id) => agencies[id-1].isShown = !agencies[id-1].isShown} /> */
                                    <AgenceCard key={agence.id+''} data={agence} hide={(id) =>{ setIsClicked(true) ; setItemClicked(id) }} itemActive={itemActive} />
                                )
                            })
                            } 
                        </div>
                    </div>
                    <div className="col-md-5 maps" onClick={() => setShowMap(true)}>
                        { 
                         showMap ?
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: 'AIzaSyAyesbQMyKVVbBgKVi2g6VX7mop2z96jBo' }}
                            defaultCenter={{
                                lat: Number(agencies[(itemActive-1)].latitude),
                                lng: Number(agencies[(itemActive-1)].longitude)
                              }}
                            defaultZoom={13}
                            >
                        <AnyReactComponent
                            lat={agencies[(itemActive-1)].latitude}
                            lng={agencies[(itemActive-1)].longitude}
                            text="ML agence"
                        />
                        </GoogleMapReact>
                        :
                        <>
                        <img src={require("../../../styles/medias/images/maps.svg")} />
                        <div className="text">
                            <a ><img src={require("../../../styles/medias/images/navigation.svg" )} />ITINERAIRE AGENCE <span>{agencies[(itemActive-1)].ville}</span></a>
                        </div> 
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>  
    )
}
